var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGodot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 20,
    role: "img",
    "aria-label": "Godot",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Godot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 61,
    height: 20,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 395,
    y: 150,
    fill: "#ccc",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 330
  }, "Godot"), /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 140,
    transform: "scale(.1)",
    fill: "#333",
    textLength: 330
  }, "Godot"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodot);
export default __webpack_public_path__ + "static/media/godot.4b3c42f205b2650cfa036ca281e646cd.svg";
export { ForwardRef as ReactComponent };